import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { useMutation } from '@tanstack/react-query'
import { toast } from 'sonner'
import type { PromotionFormData } from '@/lib/validations/promotion'
import type { AxiosError } from 'axios'
import type { ErrorResponse } from '@/types/common'
import type { PromotionItem } from '@/types/promotion'
import FormPromotion from '@/components/PromotionManagement/FormPromotion'
import { PromotionService } from '@/services/promotion'
import { PromotionStatus } from '@/types/promotion'

export const Route = createFileRoute('/_authenticated/promotions/create/')({
  component: CreatePromotionPage,
})

function CreatePromotionPage() {
  const navigate = useNavigate()
  const mutationCreate = useMutation({
    mutationFn: (data: Partial<PromotionItem>[]) => {
      return PromotionService.create(data)
    },
    onSuccess: () => {
      toast.success('Tạo chương trình khuyến mãi thành công')
      navigate({ to: '/promotions' })
    },
    onError: (error: AxiosError<ErrorResponse>) => {
      toast.error(error.response?.data.message)
    },
  })
  const handleSubmit = (data: Partial<PromotionFormData>) => {
    const payload: Partial<PromotionItem> = {
      ...data,
      discountPercentage: Number(data.discountPercentage),
      quota: Number(data.quota),
      minOrderValueVND: Number(data.minOrderValueVND),
      maxDiscountValueVND: Number(data.maxDiscountValueVND),
      minOrderValueUSD: Number(data.minOrderValueUSD),
      maxDiscountValueUSD: Number(data.maxDiscountValueUSD),
      status: PromotionStatus.ACTIVE,
      validFrom: data.validFrom
        ? new Date(data.validFrom).toISOString()
        : undefined,
      validTo: data.validTo ? new Date(data.validTo).toISOString() : undefined,
    }
    mutationCreate.mutate([payload])
  }

  return (
    <div>
      <FormPromotion
        initialData={undefined}
        onSubmit={handleSubmit}
        isLoading={mutationCreate.isPending}
      />
    </div>
  )
}
